import g from '#core/global';
import load from '#core/load';
import layout from '#core/layout';
import util from '#core/util';
import pattern_config from '#core/pattern-config';
import expandable from '#partial/expandable/expandable';


const footer_$ = '[data-hero-footer]';
const toggle_$ = '.expandable-button--hero';
const desktop_breakpoint = pattern_config.hero.layout_switch;

let $toggles = [];


const module = {
	/**
	 * Init module
	 */
	init() {
		if (load.ran('hero')) return false;

		load.content(() => {
			$toggles = Array.from(document.querySelectorAll(`${footer_$} ${toggle_$}`));
			if (!$toggles.length) return false;

			check_breakpoint();
		});

		load.all(() => {
			window.addEventListener(g.resize_e, util.throttle(() => {
				check_breakpoint();
			}, 150));
		});
	},
};

export default module;
module.init();


/**
 * Toggle expandable sections based on viewport breakpoint
 */
function check_breakpoint() {
	$toggles.forEach($toggle => {
		const id = $toggle.getAttribute(expandable.target_attr);
		expandable.toggle({
			id: id,
			force: layout.isBreakpointMin(desktop_breakpoint),
		});
	});
}
